"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleClassName = void 0;
var toggleClassName = function (element, className, action) {
    switch (action) {
        case 'add':
            element === null || element === void 0 ? void 0 : element.classList.add(className);
            break;
        case 'remove':
            element === null || element === void 0 ? void 0 : element.classList.remove(className);
            break;
        default:
            element === null || element === void 0 ? void 0 : element.classList.toggle(className);
    }
};
exports.toggleClassName = toggleClassName;
